import { Link, Typography } from '@one-thd/sui-atomic-components';
import React from 'react';

export const HelpDialogBox = () => {
  return (
    <div
      className="sui-mx-2 sm:sui-ms-10 md:sui-mx-40 xl:sui-mx-0"
      style={{
        border: '1px solid #CCC',
      }}
    >
      <div className="sui-flex sui-p-1 sui-mb-[5px]">
        <img
          src="https://assets.thdstatic.com/images/v1/StoreAssociate.svg"
          alt="Store associate"
          width="25px"
          height="25px"
          style={{ marginRight: '10px' }}
          loading="lazy"
          decoding="async"
        />
        <Typography variant="h5">
          Questions About Your Order?
          <br /> We&apos;re Here to help
        </Typography>
      </div>
      <div className="sui-flex sui-flex-row sui-flex-wrap sui-gap-2 sui-p-1">
        <div className="sui-w-full">
          <Typography variant="body-base">
            See our{' '}
            <Link href="https://www.homedepot.com/c/customer_service">
              Online FAQs
            </Link>
            , or call us:
          </Typography>
        </div>
        <div className="sui-w-full">
          <Typography variant="body-base">
            Online Orders: 1-800-430-3376
          </Typography>
        </div>
        <div className="sui-w-full">
          <Typography variant="body-base">
            In-Store Purchases: 1-800-HOME-DEPOT (466-3337)
          </Typography>
        </div>
        <div className="sui-w-full">
          <Typography variant="body-base">
            Major Appliances: 1-877-946-9843
          </Typography>
        </div>
        <div className="sui-w-full">
          <Typography variant="body-base">
            We&apos;re available from <strong>6 a.m. to 2 a.m.</strong> EST, 7
            days a week.
          </Typography>
        </div>
      </div>
    </div>
  );
};
